module.exports = __webpack_public_path__ + "img/17.438f58e2.png";